import "core-js/modules/es.array.push.js";
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d4db11d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex-none aside"
};
const _hoisted_2 = {
  class: "nav"
};
const _hoisted_3 = {
  class: "nav-main"
};
const _hoisted_4 = {
  class: "padding-l-16 padding-r-16"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "ellipsis username"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "flex-grow-1 ellipsis username"
};
const _hoisted_10 = {
  class: "nav-container"
};
const _hoisted_11 = {
  class: "padding-l-16 padding-r-16"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split-line"
}, null, -1));
const _hoisted_13 = {
  class: "padding-l-16 padding-r-16"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split-line"
}, null, -1));
const _hoisted_15 = {
  class: "padding-l-16 padding-r-16"
};
const _hoisted_16 = {
  class: "padding-l-16 padding-r-16 nav-footer"
};
const _hoisted_17 = ["src"];
import NavItem from "./NavItem.vue";
import logoImg from "@/assets/img/logo.png";
import eventListIcon from "@/assets/img/pc-first/event-list-inactive.svg";
import eventListHighlightIcon from "@/assets/img/pc-first/event-list-active.svg";
import artworkListIcon from "@/assets/img/pc-first/nft-list-inactive.svg";
import artworkListHighlightIcon from "@/assets/img/pc-first/nft-list-active.svg";
import attachmentListInactiveIcon from "@/assets/img/pc-first/attachment-list-inactive.svg";
import attachmentListActiveIcon from "@/assets/img/pc-first/attachment-list-active.svg";
import creatorInfoIcon from "@/assets/img/pc-first/creator-info-inactive.svg";
import creatorInfoHighlightIcon from "@/assets/img/pc-first/creator-info-active.svg";
import ticketListInactiveIcon from "@/assets/img/pc-first/ticket-list-inactive.svg";
import ticketListActiveIcon from "@/assets/img/pc-first/ticket-list-active.svg";
import linkIcon from "@/assets/img/pc-first/link-icon.png";
import SwitchLanguageButton from "@/components/switch-language-button/index.vue";
import defaultCreatorAvatar from "@/assets/img/pc-first/default-creator-avatar.svg";
import { ref, onMounted, onBeforeUnmount } from "vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store/modules/user";
import router from "@/router";
import { useI18n } from "vue-i18n";
import { getMultiLangValue } from "@/utils/tool";
import { logout } from "@/api/base/login_signup_logout";
import { useAppStore } from "@/store/modules/app";
export default {
  __name: 'AsideView',
  props: {
    disabledSwitchCreator: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const appStore = useAppStore();
    const props = __props;
    const {
      t,
      locale
    } = useI18n();
    const {
      isLogin,
      isCreator,
      registerEmail,
      currentManagedCreator,
      creatorInfo
    } = storeToRefs(useUserStore());
    const FAQ_URL = ref(process.env.VUE_APP_FAQ);
    const panelContainerRef = ref();
    const panelRef = ref();
    const showPanel = ref(false);
    function toggleShowPanel() {
      showPanel.value = !showPanel.value;
    }
    function toHomePage() {
      showPanel.value = false;
      router.push({
        path: "/"
      });
    }
    function onClick(e) {
      if (e.target !== panelContainerRef.value && e.target?.parentNode !== panelContainerRef.value && panelRef.value) {
        showPanel.value = false;
      }
    }
    onMounted(() => {
      window.addEventListener("click", onClick);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("click", onClick);
    });
    function toMinePage() {
      router.replace("/mine");
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("aside", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("main", _hoisted_3, [_createElementVNode("section", _hoisted_4, [_createElementVNode("img", {
        class: _normalizeClass(["pointer logo", {
          'cursor-default': _ctx.$route.name === 'home'
        }]),
        src: _unref(logoImg),
        alt: "",
        onClick: toHomePage
      }, null, 10, _hoisted_5), _unref(isLogin) && !_unref(isCreator) ? (_openBlock(), _createElementBlock("article", {
        key: 0,
        ref_key: "panelContainerRef",
        ref: panelContainerRef,
        class: _normalizeClass(["pointer relative user-info", {
          'cursor-default': _ctx.$route.name === 'home'
        }]),
        onClick: toggleShowPanel
      }, [_createElementVNode("img", {
        class: "avatar",
        src: _unref(defaultCreatorAvatar),
        alt: ""
      }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(registerEmail)), 1), showPanel.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "panelRef",
        ref: panelRef,
        class: "absolute to-home-btn",
        onClick: _withModifiers(toHomePage, ["stop"])
      }, _toDisplayString(_ctx.$t("layout.to_home")), 513)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _unref(isLogin) && _unref(isCreator) ? (_openBlock(), _createElementBlock("article", {
        key: 1,
        ref_key: "panelContainerRef",
        ref: panelContainerRef,
        class: "pointer relative user-info",
        onClick: toggleShowPanel
      }, [_createElementVNode("img", {
        class: "avatar",
        src: _unref(currentManagedCreator).logo || _unref(creatorInfo).logo || _unref(defaultCreatorAvatar),
        alt: ""
      }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(getMultiLangValue)(_unref(currentManagedCreator).creator_name, _unref(locale)) || _unref(registerEmail)), 1), showPanel.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "panelRef",
        ref: panelRef,
        class: "absolute to-home-btn",
        onClick: _withModifiers(toHomePage, ["stop"])
      }, _toDisplayString(_ctx.$t("layout.to_home")), 513)) : _createCommentVNode("", true)], 512)) : _createCommentVNode("", true)]), _createElementVNode("article", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(NavItem, {
        "icon-url": _unref(eventListIcon),
        "active-icon-url": _unref(eventListHighlightIcon),
        name: _unref(t)('layout.events'),
        path: "/event-list"
      }, null, 8, ["icon-url", "active-icon-url", "name"]), _createVNode(NavItem, {
        "icon-url": _unref(artworkListIcon),
        "active-icon-url": _unref(artworkListHighlightIcon),
        name: _unref(t)('layout.NFTs'),
        path: "/artwork-list"
      }, null, 8, ["icon-url", "active-icon-url", "name"]), _createVNode(NavItem, {
        "icon-url": _unref(attachmentListInactiveIcon),
        "active-icon-url": _unref(attachmentListActiveIcon),
        name: _unref(t)('layout.attachments'),
        path: "/attachment-list"
      }, null, 8, ["icon-url", "active-icon-url", "name"])]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(NavItem, {
        "icon-url": _unref(creatorInfoIcon),
        "active-icon-url": _unref(creatorInfoHighlightIcon),
        name: _unref(t)('layout.creator_info'),
        path: _unref(isLogin) ? '/creator-info' : '/mine'
      }, null, 8, ["icon-url", "active-icon-url", "name", "path"])]), _hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(NavItem, {
        "icon-url": _unref(ticketListInactiveIcon),
        "active-icon-url": _unref(ticketListActiveIcon),
        name: _unref(t)('layout.ticket_list'),
        path: "/ticket-list"
      }, null, 8, ["icon-url", "active-icon-url", "name"])])])]), _createElementVNode("footer", _hoisted_16, [_createVNode(NavItem, {
        name: "FAQ",
        path: FAQ_URL.value
      }, {
        suffix: _withCtx(() => [_createElementVNode("img", {
          class: "link-icon",
          src: _unref(linkIcon),
          alt: ""
        }, null, 8, _hoisted_17)]),
        _: 1
      }, 8, ["path"]), _createVNode(NavItem, {
        name: _unref(t)('layout.language')
      }, {
        suffix: _withCtx(() => [_createVNode(SwitchLanguageButton)]),
        _: 1
      }, 8, ["name"]), !_unref(isLogin) ? (_openBlock(), _createBlock(NavItem, {
        key: 0,
        name: _unref(t)('layout.login'),
        cursor: "",
        onClick: toMinePage
      }, null, 8, ["name"])) : (_openBlock(), _createBlock(NavItem, {
        key: 1,
        name: _unref(t)('layout.logout'),
        cursor: "",
        onClick: _unref(logout)
      }, null, 8, ["name", "onClick"]))])])]);
    };
  }
};